import React from "react";
import { motion } from "framer-motion";
import "./PainPointBand.css";

export default function PainPointBand() {
  return (
    <section className="pain-band">
      <div className="container pain-band__inner">
        <motion.div
          className="pain-band__content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="pain-band__rule" aria-hidden="true" />
          <h2 className="pain-band__title">Hiring across borders is hard.</h2>
          <p className="pain-band__body">
            Bad CVs. Visa delays. Crews that don&rsquo;t show.
            <br />
            Then the project slips.
          </p>
          <p className="pain-band__closer">
            That&rsquo;s the problem{" "}
            <span className="pain-band__accent">Adel was built to solve.</span>
          </p>
        </motion.div>
      </div>
    </section>
  );
}
